const theme = {
  colors: {
    base: "#121212", // Black
    secondary: "#e9e9e9", // Medium Gray
    tertiary: "#f3f3f3", // Light Gray
    highlight: "#5b8bf7", // Light Blue

    black: "#2A2A2A",
    ash: "#F2F2F2",
    lightGrey: "#E6E6E6",
    baseGrey: "#929292",
    baseGreyHover: "#9f9f9f",
    darkGrey: "#626262",

    coralDark: "#E07064",
    coral: "#EE7F73",
    coralLight: "#ff8b78",
    gold: "#F3D5A4",
    blue: "#2872D3",
    darkBlue: "#004DB3",
    paper: "#ffffff",
    white: "#ffffff",
  },

  fontStacks: {
    serif: `"Tiempos", Georgia, Constantia, "Lucida Bright", Lucidabright, "Lucida Serif", Lucida, "DejaVu Serif", "Bitstream Vera Serif", "Liberation Serif", serif`,
    serifHeadline: `"TiemposHeadline", Georgia, Constantia, "Lucida Bright", Lucidabright, "Lucida Serif", Lucida, "DejaVu Serif", "Bitstream Vera Serif", "Liberation Serif", serif`,
    sans: `Metric, 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif`,
  },

  breakpoints: {
    xs: 0,
    vs: 320, // very small :)
    sm: 576,
    md: 768,
    lg: 1000,
    xl: 1400,
  },

  spacing: {
    "-2": `-16px`,
    "-1": `-8px`,
    0: `0`,
    1: `8px`,
    2: `16px`,
    3: `24px`,
    4: `32px`,
    5: `40px`,
    6: `48px`,
    7: `56px`,
    8: `64px`,
    10: `80px`,
  },

  sideBarWidth: 276,
  menuHeight: 64,
}

export default theme

// Convenience bc i got sick of typing the theme provider
export const sansFontStack = theme.fontStacks.sans
export const serifsFontStack = theme.fontStacks.serif
